import queryString from 'query-string';
import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';
import { List } from '../interfaces/payout.interface';
import { mapPayoutList } from '../mappers/payout.mapper';

const list = (payload: List) => {
  const { searchText, startDate, endDate, property, managedBy, platform, bankAccount, payoutType, payoutStatus, reservationStatus, action, payoutManagedBy, checkoutOnly, ...others } = payload;
  const paging = buildPagingResponse(others);

  const url = `${API_ENDPOINTS.listPayouts}?${queryString.stringify(paging)}`;
  return http.post(url, {
    property_id: property || undefined,
    platform_id: platform || undefined,
    reconciliation_status: payoutStatus || undefined,
    start_date: startDate || undefined,
    end_date: endDate || undefined,
    reservation_status: reservationStatus || undefined,
    bank_name: bankAccount || undefined,
    payout_type: payoutType || undefined,
    reconciliation_verification: action === '__blank__' ? '' : (action || undefined),
    managed_by: managedBy || undefined,
    payout_manage_by: payoutManagedBy || undefined,
    only_checkout: checkoutOnly || undefined,
    search: searchText || '',
  }).then((res: any) => mapPayoutList(res));
};

const lookupBankAccounts = (_payload: { searchText: string }) => {
  const url = `${API_ENDPOINTS.lookupPayoutBankAccounts}?${queryString.stringify({ search: _payload.searchText })}`;
  return http.get(url);
};

const lookupPayoutTypes = (_payload: { searchText: string }) => {
  const url = `${API_ENDPOINTS.lookupPayoutTypes}?${queryString.stringify({ search: _payload.searchText })}`;
  return http.get(url);
};

const saveNote = (id: string, payload: any) => {
  return http.put(`${API_ENDPOINTS.payouts}/${id}`, payload);
};

const addPayout = (reservationId: string, payload: any) => {
  return http.put(API_ENDPOINTS.addPayout(reservationId), payload);
};

const sync = () => {
  return http.post(API_ENDPOINTS.syncPayouts);
};

const PayoutService = {
  list,
  lookupBankAccounts,
  lookupPayoutTypes,
  saveNote,
  addPayout,
  sync,
};

export default PayoutService;
